/*  i'll be mixed in Analysen.vue */
import moment from "moment";
export default {
  data() {
    return {
      fields: [
        {
          key: "BTRAGISID",
          label: this.$t("AGISB"),
          sortable: true,
          class: "text-right"
        },
        {
          key: "MPDDATUM",
          label: this.$t("Datum"),
          sortable: true,
          class: "text-right"
        },
        {
          key: "ANATYPCODE",
          label: this.$t("Probetyp"),
          sortable: true,
          class: "text-right"
        },
        {
          key: "MPDKEIME",
          threshold: 80000,
          label: this.$t("Keime") + " (" + this.$t("Anzahl") + "/ml)",
          sortable: true,
          formatter: value => {
            return !value ? "" : parseInt(value).toLocaleString("de-CH");
          },
          class: "text-right"
        },
        {
          key: "MPDZELLEN",
          label: this.$t("Zellen") + " (" + this.$t("Anzahl") + "/ml)",
          sortable: true,
          threshold: 350000,
          formatter: value => {
            return !value ? "" : parseInt(value).toLocaleString("de-CH");
          },
          class: "text-right"
        },
        {
          key: "MPDHEMMSTOFF",
          label: this.$t("Hemmstoff"),
          sortable: true,
          class: "text-right"
        },
        {
          key: "MPDGEFRIERPUNKT",
          //threshold: -0.516, MJ #976 Ausblenden
          label: this.$t("Gefrierpunkt") + " (°C)",
          formatter: value => {
            return !value ? "" : parseFloat(value).toFixed(3);
          },
          sortable: true,
          class: "text-right"
        },
        {
          key: "MPDGEFRIERPUNKT2",
          label: this.$t("AdaptionGP") + " (°C)",
          formatter: value => {
            return !value ? "" : parseFloat(value).toFixed(3);
          },
          sortable: true,
          class: "text-right"
        },
        {
          key: "MPDGEFRIERPUNKT75",
          label: this.$t("Q75plus") + " (°C)",
          formatter: value => {
            return !value ? "" : parseFloat(value).toFixed(3);
          },
          sortable: true,
          class: "text-right"
        },
        {
          key: "MPDFETT",
          label: this.$t("Fett") + " (g/100g)",
          sortable: true,
          class: "text-right"
        },
        {
          key: "MPDEIWEISS",
          label: this.$t("Eiweiss") + " (g/100g)",
          sortable: true,
          class: "text-right"
        },
        {
          key: "MPDHARNSTOFF",
          label: this.$t("Harnstoff") + " (mg/100ml)",
          sortable: true,
          class: "text-right"
        },
        {
          key: "MPDFETTSAEUREN",
          label: this.$t("AnaIntFld33") + " (mmol/10kg)",
          sortable: true,
          class: "text-right"
        },
        {
          key: "MPDKASEIN",
          label: this.$t("Kasein") + " (g/100g)",
          sortable: true,
          class: "text-right"
        },
        {
          key: "MPDCLOSTRIDIEN",
          label: this.$t('Clostridien').replace('urespo', 'ure-spo')+' ('+this.$t('Sporen')+'/l)',
          sortable: true,
          class: "text-right"
        },
        {
          key: "MPDREFCODELABOR",
          label: "Ref.-Lab.",
          sortable: true,
          class: "text-right"
        },
        {
          key: "MPDMSGCODELABOR",
          label: this.$t("Fehlercode"),
          sortable: true,
          class: "text-right"
        }
      ]
    }
  },
  computed: {
    analysenFilter() {
      return {
        von: moment(this.$store.state.searchStore.searchValues.von).toDate(),
        bis: this.$store.state.searchStore.searchValues.bis,
        anatypID: this.$store.state.analysenStore.anatypSelected,
        tierartID: this.$store.state.searchStore.searchValues.tierartSelected,
        btrID: this.$store.state.searchStore.searchValues.betriebSelected,
      }
    },
    analysen() {
      return this.$store.state.analysenStore.analysenFiltered;
    },
    betriebSelectedBtrIDs() {
      return this.$store.state.searchStore.searchValues.betriebSelectedBtrIDs;
    },
    latestRefID() {
      return this.$store.state.analysenStore.latestRefID;
    },
    betriebe() {
      return this.$store.state.betriebeStore.betriebe;
    },
    token() {
      return this.$store.state.userStore.token;
    },
    sortBy: {
      get() {
        return this.$store.state.analysenStore.sortTable.sortBy;
        //return this.$store.state.analysenStore.sortTable.sortBy
      },
      set(val) {
        this.$store.commit("setAnalysenSortTableBy", val);
      }
    },
    sortDesc: {
      get() {
        return this.$store.state.analysenStore.sortTable.sortDesc;
      },
      set(val) {
        this.$store.commit("setAnalysenSortTableDesc", val);
      }
    },
    load() {
      return this.$store.state.analysenStore.load;
    }
  },
  methods: {
    formatDate(dateX) {
      return moment(dateX)
        .locale("de-CH")
        .format("L");
    },
    showDetail(refcodelabor) {
      this.$refs.analysenDetail.open(refcodelabor);
    },
    getLatestRefID: function() {},
    filterAnalysen: function() {
      this.$store.dispatch("buildFilteredAnalyen", this.analysenFilter);
    },
    loadAnalysen: async function() {
      let self = this;
      if (this.load.resetedOn + this.load.intervall < new Date().getTime()) {
        await this.$store.dispatch("resetAnalysen", this.analysenFilter);
        this.analysen.sort(function(a, b) {
          return self.sortCompare(a, b, self.sortBy);
        });
      }
    },
    sortCompare: function(a, b, key) {
      if (key === "MPDDATUM") {
        return moment(a[key]) < moment(b[key])
          ? -1
          : moment(a[key]) > moment(b[key])
            ? 1
            : 0;
      }
      if (typeof a[key] === "number" && typeof b[key] === "number") {
        // If both compared fields are native numbers
        return a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0;
      } else {
        if (a[key] < b[key]) return -1;
        if (a[key] > b[key]) return 1;
        return 0;
      }
    }
  },
  created() {
    let self = this;
    this.$nextTick(async function() {
      self.filterAnalysen();
    });
  },
  updated() {},
  mounted() {
    this.loadAnalysen();
    this.analysenIntervall = window.setInterval(
      this.loadAnalysen,
      this.load.tic
    );
  },
  beforeDestroy() {
    window.clearInterval(this.analysenIntervall);
  },
  watch: {
    'analysenFilter.von'() {
      this.$store.dispatch("loadAnalysen", this.analysenFilter);
    },
    'analysenFilter.bis'() {
      this.$store.dispatch("loadAnalysen", this.analysenFilter);
    }
  }
}